export default __webpack_public_path__ + "static/media/icon-4.62ac7d3b.svg";